import { render, staticRenderFns } from "./RichDetailInput.vue?vue&type=template&id=6c6ef707&scoped=true"
import script from "./RichDetailInput.vue?vue&type=script&lang=js"
export * from "./RichDetailInput.vue?vue&type=script&lang=js"
import style0 from "./RichDetailInput.vue?vue&type=style&index=0&id=6c6ef707&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6ef707",
  null
  
)

export default component.exports